import LoggedOutIcon from 'src/assets/svg/logged-out-icon';
import LoginLayout from 'src/modules/layout/login-layout';
import AccessDenied from 'src/modules/login/access-denied';

const RestrictedSectionContainer  = () => {
	return (
		<LoginLayout>
			<AccessDenied
				infoText={
					<>
						Oops! You don't have access to <br />
						this section.
					</>
				}
			/>
		</LoginLayout>
	);
};

export default RestrictedSectionContainer;